import css from 'styled-jsx/css';

const styles = css.global`.numeric-bullet {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: center;
  gap: 24px;
}

.numeric-bullet .numeric-item {
  min-width: 15px;
  color: #222;
  text-align: center;

  /* 768/Body */
  font-family: 'SantanderText';
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 155.556% */
  cursor: pointer;
}

.numeric-bullet .numeric-item.active {
  color: #c00;
  text-align: center;

  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

.numeric-bullet.hidden {
  display: none;
}`;

export default styles;